import little_guys from "./object-lists/littleguys";
function Hatchery(props) {
   
    const listGuys = little_guys.map(temp =>
        <div className="little-guy">
            <a target="_blank" rel="noopener noreferrer" href={temp.href}><img src={temp.src} style={{borderWidth: 0}} /></a>
            <p className="little-guy-name">{temp.title}</p>
        </div>
    );
    

    return (
        <div className= {props.hatchery?'hatchery-wrapper':'page-hidden'}> 
            <button className='x-close' onClick={()=>props.handlePages("main")}>{'<'}--- back to home</button>
            <div className="hatchery-title">please click my eggs</div>
            <br></br>
            <p>Click on a creature to check in on it!</p>
            <p>Dragon eggs need clicks to live. If you don't see any, that means they all hatched! Yay! </p>
            <p>Adult dragons can fend for themselves, but appreciate the visit. </p>
            <p>The other ones... please check them to make sure they don't breach containment.</p>
            <div className="little-guys">
                {listGuys}
            </div>
        </div>
    );
  }

  export default Hatchery;